import React from "react";

const Card = (props: { children: React.ReactNode }) => {
  return (
    <div className="w-inherit h-inherit flex flex-col px-6 py-6 items-start justify-start rounded-lg bg-white shadow-cardShadow">
      {props.children}
    </div>
  );
};

export default Card;
